export default __webpack_public_path__ + "static/media/8.0e8750c2.png";